import { PostApiSpoChatbotBodyMessagesItem } from '@spo/types';
import { VpIcon } from '@vtmn-play/react/headless';
import clsx from 'clsx';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import './chatbot.scss';

export const ChatbotMessages = ({
  messages,
  isPending,
  isError,
}: {
  messages: PostApiSpoChatbotBodyMessagesItem[];
  isPending: boolean;
  isError: boolean;
}) => {
  const scrollRef = useRef<HTMLDivElement>(null);
  const { t } = useTranslation();

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [messages, isPending, isError]);

  const displayLineBreaks = (text: string, role: string) => {
    const splittedText = text.split('\\n');
    return splittedText.map((txt) => (
      <div
        className={`message-line-${role.toLowerCase()}`}
        key={`${role.toLowerCase()}-${txt}`}
      >
        {txt}
      </div>
    ));
  };

  return (
    <div
      className="chatbot-content"
      ref={scrollRef}
      data-testid="chatbot_content"
    >
      <div className="message-intro agent" data-testid="message_intro">
        <div>{t('chatbot.opening-message.line1')}</div>
        <div>{t('chatbot.opening-message.line2')}</div>
        <div>{t('chatbot.opening-message.line3')}</div>
        <div>{t('chatbot.opening-message.line4')}</div>
        <div>{t('chatbot.opening-message.line5')}</div>
        <div>{t('chatbot.opening-message.line6')}</div>
      </div>
      {messages.map((msg, index) => (
        <div
          className={clsx('message', msg.role.toLowerCase())}
          data-testid={`message_${msg.role.toLowerCase()}`}
          key={`${msg.text} - ${index}`}
        >
          {displayLineBreaks(msg.text, msg.role.toLowerCase())}
        </div>
      ))}
      {isPending && (
        <div className="chatbot-loader" data-testid="chatbot_loader"></div>
      )}
      {isError && (
        <div className="error-message" data-testid="chatbot_error">
          <VpIcon name="emotion-sad" />
          {t('chatbot.error-message')}
        </div>
      )}
    </div>
  );
};
